import React from 'react'
import Banner from './Banner'


import FertilitySection from './FertilitySection';

import CenterContent from './CenterContent';
import AboutBanner from './AboutBanner';






const Home = () => {
  return (
    <div>
       <br />
        <Banner/> <br />
     
        <CenterContent/>
        <FertilitySection/>
        <AboutBanner/>
       
        <br /><br />
        <hr />
      
      
         
       
      
    </div>
  )
}

export default Home
